import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

// 添加这下面一段代码，就可以解决报错 
 
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

const commonRoutes = [
    {
        path: '/login',
        name: 'login',
        component:()=>import('../components/Login.vue')
    },
    {
        path: '/selectUser',
        name: 'selectUser',
        component: () => import('../components/selectUser.vue')
    },
    {
        path: '/treegrid',
        name: 'treegrid',
        component: () => import('../components/TreeGrid.vue')
    },
    {
        path: '/userexpand',
        name: 'userexpand',
        component: () => import('../components/userExpand.vue')
    },
    {path: '/', redirect: '/home'},
    {   
        path: 'error',
        name: 'error',
        component: () => import('../components/Error.vue')
    },{
        path: '/',
        component: () => import('../components/Index.vue'),
        children:[
            {
                path: 'myhome',
                name: 'myhome',
                component: () => import('../views/myHome.vue')
            },{
                path: 'home',
                name: 'home',
                component: () => import('../views/Home.vue')
            },{
                path: 'password',
                name: 'password',
                component: () => import('../views/Password.vue')
            },{
                path: 'menulist',
                name: 'menulist',
                component: () => import('../views/menuList.vue')
            },{
                path: 'userinfo',
                name: 'userinfo',
                component: () => import('../views/UserInfo.vue')
            },{
                path: 'pfuser',
                name: 'pfuser',
                component: () => import('../views/PFuser.vue')
            },{
                path: 'mypfuser',
                name: 'mypfuser',
                component: () => import('../views/myPFuser.vue')
            },{
                path: 'adminuser',
                name: 'adminuser',
                component: () => import('../views/adminUser.vue')
            },{
                path: 'operalog',
                name: 'operalog',
                component: () => import('../views/operaLog.vue')
            },{
                path: 'elecstationlist',
                name: 'elecstationlist',
                component: () => import('../views/elecStationList.vue')
            },{
                path: 'myelecstationlist',
                name: 'myelecstationlist',
                component: () => import('../views/myelecStationList.vue')
            },{
                path: 'devicelist',
                name: 'devicelist',
                component: () => import('../views/deviceList.vue')
            },{
                path: 'mydevicelist',
                name: 'mydevicelist',
                component: () => import('../views/mydeviceList.vue')
            },{
                path: 'investactivity',
                name: 'investactivity',
                component: () => import('../views/investActivity.vue')
            },{
                path:'spuser',
                name:'spuser',
                component:()=>import('../views/SmallProgramUser.vue')
            },{
                path:'stationlist',
                name:'stationlist',
                component:()=>import('../views/stationList.vue')
            },{
                path:'mystationlist',
                name:'mystationlist',
                component:()=>import('../views/mystationList.vue')
            },{
                path:'investlist',
                name:'investlist',
                component:()=>import('../views/investList.vue')
            },{
                path:'myinvestlist',
                name:'myinvestlist',
                component:()=>import('../views/myinvestList.vue')
            },{
                path:'errorlist',
                name:'errorlist',
                component:()=>import('../views/errorList.vue')
            },{
                path:'myerrorlist',
                name:'myerrorlist',
                component:()=>import('../views/myerrorList.vue')
            },{
                path:'userbalance',
                name:'userbalance',
                component:()=>import('../views/userBalance.vue')
            },{
                path:'myuserbalance',
                name:'myuserbalance',
                component:()=>import('../views/myuserBalance.vue')
            },{
                path:'cardmodule',
                name:'cardmodule',
                component:()=>import('../views/cardModule.vue')
            },{
                path:'cardbalancelist',
                name:'cardbalancelist',
                component:()=>import('../views/cardBalanceList.vue')
            },{
                path:'mycardbalancelist',
                name:'mycardbalancelist',
                component:()=>import('../views/mycardBalanceList.vue')
            },{
                path:'resource',
                name:'resource',
                component:()=>import('../views/resource.vue')
            },{
                path:'rolemodel',
                name:'rolemodel',
                component:()=>import('../views/roleModel.vue')
            },{
                path:'wechat',
                name:'wechat',
                component:()=>import('../views/wechat.vue')
            },{
                path:'mywechat',
                name:'mywechat',
                component:()=>import('../views/myWechat.vue')
            },{
                path: 'error',
                name: 'error',
                component: () => import('../components/Error.vue')
            },{
                path: 'myassigndevice',
                name: 'myassigndevice',
                component: () => import('../views/myassignDevice.vue')
            },{
                path: 'myhome',
                name: 'myhome',
                component: () => import('../views/myHome.vue')
            },{
                path: 'cardactivelist',
                name: 'cardactivelist',
                component: () => import('../views/cardActiveList.vue')
            },{
                path: 'mycardactivelist',
                name: 'mycardactivelist',
                component: () => import('../views/mycardActiveList.vue')
            },{
                path: 'cardrechargelist',
                name: 'cardrechargelist',
                component: () => import('../views/cardrechargeList.vue')
            },{
                path: 'mycardrechargelist',
                name: 'mycardrechargelist',
                component: () => import('../views/mycardrechargeList.vue')
            },{
                path:'welcomepage',
                name:'welcomepage',
                component: () => import('../components/welcomePage.vue')
            },{
                path:'muserbalance',
                name:'muserbalance',
                component:()=>import('../views/muserBalance.vue')
            },{
                path:'sysbalance',
                name:'sysbalance',
                component:()=>import('../views/sysBalance.vue')
            },{
                path:'mymuserbalance',
                name:'mymuserbalance',
                component:()=>import('../views/mymuserBalance.vue')
            },{
                path:'transactionBalance',
                name:'transactionBalance',
                component:()=>import('../views/transactionBalance.vue')
            },{
                path:'cashRecords',
                name:'cashRecords',
                component:()=>import('../views/cashRecords.vue')
            },{
                path:'settleCenter',
                name:'settleCenter',
                component:()=>import('../views/settleCenter.vue')
            },{
                path:'parkList',
                name:'parkList',
                component:()=>import('../views/parkList.vue')
            },{
                path:'parkUser',
                name:'parkUser',
                component:()=>import('../views/parkUser.vue'),
                meta:['停车场商户']
            },{
                path:'withdrawList',
                name:'withdrawList',
                component:()=>import('../views/withdrawList.vue')
            },{
                path:'userBalancePay',
                name:'userBalancePay',
                component:()=>import('../views/userBalancePay.vue')
            }
        ],
    },
    {path: 'nullMenu',name:'/' || 'nullMenu', redirect: '/error'}
]

const createRouter = () => new Router({
    mode:'history',
    routes: commonRoutes
})

//一进入就会执行
const router = createRouter()

//只有退出登录时才会执行此函数
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher 
}


export default router


// WEBPACK FOOTER //
// ./src/router/index.js